import { useTranslation } from 'react-i18next';

import { useAnalytics } from '@bonusly/analytics';
import { useToast } from '@bonusly/design-system';

import { useCreateBookmark } from '../components/bookmark/hooks/use-create-bookmark';
import { useDeleteBookmark } from '../components/bookmark/hooks/use-delete-bookmark';
import { useBookmark } from '../context';
import { BookmarkEvent } from '../types/event';

export const useBookmarkToggle = () => {
	const { t } = useTranslation('bookmarks');
	const { track } = useAnalytics();
	const { bookmark, referenceId, referenceType } = useBookmark();
	const toast = useToast();

	const isBookmarked = bookmark !== undefined;

	const options = {
		onSuccess: (response: any) => {
			let title = t('success_create');
			let event = BookmarkEvent.NewBookmark;

			if (response.config.method === 'delete') {
				event = BookmarkEvent.UnsaveBookmark;
				title = t('bookmark_modal.success_delete');
			}

			track(event);

			toast({
				position: 'top-right',
				title,
				isClosable: true,
				status: 'success',
			});
		},
	};

	const { mutate: createBookmark } = useCreateBookmark({ options });
	const { mutate: deleteBookmark } = useDeleteBookmark({
		options,
		id: bookmark?.id,
	});

	const toggleBookmark = () => {
		if (isBookmarked) {
			deleteBookmark();
			return;
		}

		createBookmark({
			notes: '',
			reference_id: referenceId,
			reference_type: referenceType,
			label_ids: [],
		});
	};

	return {
		isBookmarked,
		toggleBookmark,
	};
};
